module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1bb",
    attrs: {
      "id": "d7e290137"
    }
  }, [_c('span', [_vm._v("florence fennel")])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e290637"
    }
  }, [_c('span', [_vm._v("(finocchio dolce)")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e291137"
    }
  }, [_c('span', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ŒNICULUM VULGARE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "2010-11-08T18-23-50-706_9781550924589_0037_001",
      "id": "d14e634",
      "src": "Images/2010-11-08T18-23-50-706_9781550924589_0037_001.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e291937"
    }
  }, [_c('span', [_vm._v("A lovely plant with feathery leaves and a fist-sized bulbous base, it resembles an elegant celery and is available in both green and bronze varieties. Both leaves and base are used, the former mostly in salads and as a garnish for fish and pork. The mild anise flavor adapts to a variety of treatments.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e293837"
    }
  }, [_c('span', [_vm._v("Shoppers should look for fresh-looking greens and firm, medium-sized bulbs. Try to buy whole plants rather than just the bulbs. You get more value, and you can judge the freshness by the leaves. Large, stringy bulbs can be deveined like celery. The bulbs keep fairly well refrigerated in a plastic bag; the greens should be used within a few days.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e296337"
    }
  }, [_c('span', [_vm._v("If you are growing fennel for the first time, locate it carefully, as it is very persistent and it gets big.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e297437"
    }
  }, [_c('span', [_vm._v("gobo")])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e297937"
    }
  }, [_c('span', [_vm._v("(burdock)")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e298437"
    }
  }, [_c('span', [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RCTIUM SPP.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e299137"
    }
  }, [_c('span', [_vm._v("This is the same genus as cocklebur, the noxious weed whose prickly, tenacious seeds were the inspiration for Velcro. It is large, deep-rooted, and nearly indestructible once established, so I hesitate to recommend it as a garden plant unless you are far more organized and disciplined than I am. On the other hand, the taste is among the best of all winter roots: full and rich, with a bittersweet edge. Besides its culinary value, Japanese gobo ("), _c('i', [_vm._v("Arctium")]), _vm._v(" "), _c('i', [_vm._v("lappa")]), _vm._v(") is widely taken in Japan to improve strength and virility, and the naturalized American varieties are used in a number of herbal remedies. You often can find gobo in Asian markets and specialty groceries.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e303738"
    }
  }, [_c('span', [_vm._v("The dark brown root is the most important culinary part. It is long—up to 18 inches—and slender; you will need to dig it, not pull it. Although the young leaves are sometimes used as a green, I find them unpleasantly hairy and bitter.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e305338"
    }
  }, [_c('span', [_vm._v("good king henry")])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e305838"
    }
  }, [_c('span', [_vm._v("(Mercury, Lincolnshire spinach, poor man’s asparagus)")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e306338"
    }
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("HONOPODIUM BONUS HENRICUS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e306838"
    }
  }, [_c('span', [_vm._v("Like sorrel and mint, this heirloom potherb is welcomed as one of the first herbs of spring. A member of the goosefoot family, as is its tasty wild relative, lambsquarters, it has thickish arrow-shaped leaves that can be steamed or mixed with milder flavors in salads. The “poor man’s asparagus” name comes from the early spring shoots, which can be picked and steamed.")])]), _vm._v(" "), _c('p', {
    staticClass: "h1b",
    attrs: {
      "id": "d7e309438"
    }
  }, [_c('span', [_vm._v("hamburg parsley")])]), _vm._v(" "), _c('p', {
    staticClass: "h3",
    attrs: {
      "id": "d7e309938"
    }
  }, [_c('span', [_vm._v("(turnip-rooted parsley)")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    attrs: {
      "id": "d7e310438"
    }
  }, [_c('span', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ETROSELENIUM CRISPUM VAR. TUBEROSUM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e310938"
    }
  }, [_c('span', [_vm._v("A variety of parsley grown for its root, which looks like a small skinny parsnip and has a nice mild parsley taste, it deserves more notice than it gets, being unfussy in the garden and very hardy. It is easier to harvest than the deep-rooted parsnip (though less productive) and much easier to clean than celeriac, and can be substituted for both in many recipes. It’s very good in stews and hearty soups and has many uses in folk medicine. The strong-flavored leaves can be substituted, sparingly, for regular parsley.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e313838"
    }
  }, [_c('span', [_vm._v("Gardeners can leave the plants in the ground through the winter and harvest as needed. Shoppers should look for crisp, solid roots and store them like carrots. They will keep for a week or two.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e07c68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Morg_9781550924589_epub_c18_r1.vue
// module id = 111
// module chunks = 0